import { makeAutoObservable, runInAction } from "mobx";

export default class NotificationStore {
  constructor() {
    makeAutoObservable(this);
  }

  notifications = [];

  showNotification = (message, type = "success", options = {}) => {
    const id = Date.now();
    const {
      duration = 4000,
      title = null, // Custom title - if null, uses default based on type
      button = null, // { text: string, onClick: function }
      autoClose = true, // Whether to auto-close
    } = options;

    const notification = {
      id,
      message,
      type, // 'success', 'error', 'info', 'warning'
      title,
      button,
      visible: true,
    };

    this.notifications.push(notification);

    if (autoClose && duration > 0) {
      setTimeout(() => {
        runInAction(() => {
          const index = this.notifications.findIndex((n) => n.id === id);
          if (index !== -1) {
            this.notifications[index].visible = false;
          }
        });

        // Remove from array after animation
        setTimeout(() => {
          runInAction(() => {
            this.notifications = this.notifications.filter((n) => n.id !== id);
          });
        }, 300);
      }, duration);
    }
  };

  closeNotification = (id) => {
    runInAction(() => {
      const notification = this.notifications.find((n) => n.id === id);
      if (notification) {
        notification.visible = false;
      }
    });

    setTimeout(() => {
      runInAction(() => {
        this.notifications = this.notifications.filter((n) => n.id !== id);
      });
    }, 300);
  };
}
